<div [innerHTML]="input"></div>

@if (flow === 'gkalgraaf') {
  <button (click)="gkalgraafyes()" mat-button>
    Ja
  </button>
  <button (click)="gkalgraafno()" mat-button>
    Nee
  </button>
}